import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-900/50">
      <div className="max-w-7xl mx-auto w-full">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按类型探索，找到你的心头好
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-800/60 hover:bg-background-700/60 border border-background-700/30 hover:border-primary-500/30 transition-all cursor-pointer animate-fade-in-up ${
                index === 0
                  ? ""
                  : index === 1
                    ? "animation-delay-100"
                    : index === 2
                      ? "animation-delay-200"
                      : index === 3
                        ? "animation-delay-300"
                        : index === 4
                          ? "animation-delay-400"
                          : "animation-delay-500"
              }`}
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-950 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-300 group-hover:text-foreground-100 whitespace-nowrap transition-colors">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-600">
                {cat.count} 部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}